import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Utility from "../../utility/Utility";
import { deepClone } from "../../utility/Utility"
import {
  DKLabel,
  DKButton,
  DKDataGrid,
  DKCalendar,
  Toggle,
  showAlert,
  DKIcons,
  showLoader,
  removeLoader,
  showToast,
  TOAST_TYPE,
  DKInput,
  DKSearchBar,
  DKTooltipWrapper,
  DKListPicker2,
  DKIcon
} from "deskera-ui-library";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { parseColumnConfig, teamAttendanceColumnConfig, AttendanceDrillDownColumnConfig, AttendanceDrillDownColumnName, parseVisibleColumnConfig, getFileName } from "../configs/config";
import { fetchTeamAttendance, selectTeamAttendance, selectTeamAttendanceColumnConfig } from "../../Redux/Slices/TeamAttendanceSlice";
import AttendanceService, { defaultTeamConfig } from "../../services/AttendanceService";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import moment from 'moment'
import { ATTENDANCE_TYPE, FORMAT, FORM_ACTIONS, INPUT_TYPE } from "../../constants/Constant";
import calender from '../../assets/icons/white/date_range.svg'
import funnel from '../../assets/menu/white/ic_funnel.png'
import { showFormPopup } from "../menu/AddNewRecordPopup";
import ApiConstants from "../../constants/ApiConstants";
import { useTranslation } from "react-i18next";
import Table from "../../services/table";
import EmployeeAttendancePopup from "./EmployeeAttendancePopup";
import Popup from "../common/Popup";
import AppManager from "../../managers/AppManager";
import ExportAttendancePopup from "./ExportAttendancePopup";
import ShiftManagementService from "../../services/ShiftManagementService";
import EmployeeListService from "../../services/EmployeeListService";
import i18next from "i18next";
import { getQueryParam, isProfessionalPlan, isWeekFilterEnable, pageScroll } from "../../managers/common/CommonUtil";
import SideBarService from "../../services/sidebar";
import { BiometricDetailsSelector, fetchBiometricDetails } from "../../Redux/Slices/BiometricSlice";
import AttachmentService from "../../services/AttachmentService";
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

let searchTimer;

const TeamReport = (props) => {
    const { t, i18n } = useTranslation();

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: ''
    };

    //State hooks
    const [refresh, setRefresh] = useState(false);
    const [attendance, setTeamAttendance] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [designations,setDesignations] = useState([]);
    const [shifts, setShifts] = useState([]);
    const [hideTerminated, setHideTerminated] = useState(false);
    const [showAttendancePopup, setShowAttendancePopup] = useState(false);
    const [attendancePopupData, setAttendancePopupData] = useState({});
    const [selectedAttendance, setSelectedAttendance] = useState({});
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [confirmationPopupData, setConfirmationPopupData] = useState({});
    const [width, setWidth] = useState(SideBarService.getContainerWidth())
    const [punchingError,setPunchingError] = useState(null);
    const initialYear = {
        toggle: false,
        startDate:  getQueryParam(props.location, "selectDate") ? moment(getQueryParam(props.location, "selectDate")):moment(),
        endDate: getQueryParam(props.location, "selectDate") ? moment(getQueryParam(props.location, "selectDate")):moment()
    }
    const [selectYear,setYear] = useState(initialYear)
    const [reload, setReload] = useState(false);
    //Store data selectors
    const dispatch = useDispatch();

    const attendanceData = useSelector(selectTeamAttendance);
    const columnConfig = useSelector(selectTeamAttendanceColumnConfig);
    const isActionEnabled = false;
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [selectedUserDetails, setSelectedUserDetails] = useState(null);
    const [enableSave, setEnableSave] = useState(false);
    const [filterWeek, setFilterWeek] = useState({
      year: new Date().getFullYear(),
      start: '',
      end:'',
      displayText:''
    })
    const [selectedDuration, setSelectedDuration] = useState('Week')
    var counterForFilter = 0;
    const [editData, setEditData] = useState();

    const biometricDetail = useSelector(BiometricDetailsSelector);
    const [showBiometricSync, setShowBiometricSync] = useState(false);
    const isAdmin = TenantService.get(TENANT.IS_ADMIN)
    const [searchName,setSearchName] = useState('');

    useEffect(() => {
      window.addEventListener("resize", windowSizeUpdated);
      window.addEventListener('onSideBarChange', windowSizeUpdated);
        RouteManager.setPresenter({ props });
        const searchNameTemp = getQueryParam(props.location, "name");
        /* API Calls Start */
        if(!isWeekFilterEnable()) {
          setSearchName(searchNameTemp);
          loadAttendance(!Utility.isEmpty(searchNameTemp) ? {...defaultTeamConfig,page: 0,search: searchNameTemp,query: `clockIn>${moment(initialYear.startDate).format(
            "YYYY-MM-DD 00:00"
          )},clockIn<${moment(initialYear.startDate).format("YYYY-MM-DD 23:59")}`}:{});
        } else {
          getSelectedDuration();
        }
        fetchDependancies();
        window.openSelectedLocation = function (latitude, longitude) {
          const link = ApiConstants.URL.GEO_LOCATION.VIEW_LOCATION(latitude, longitude);
          window.open(link, "_blank", "noopener");
        };
        /* API Calls End */
        return () => {
            pageScroll(true)
            window.removeEventListener("resize", windowSizeUpdated);
            window.removeEventListener('onSideBarChange', windowSizeUpdated);
            window.openSelectedLocation = () => {};
            setTeamAttendance(initialState)};
            
              
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(attendanceData)) {
            const { attendances, filterConfig } = attendanceData;
            const rowData = teamAttendanceColumnConfig(attendances, getExpandableView);
            const attendanceColumn = parseVisibleColumnConfig(parseColumnConfig(changeShiftColumnPosition(TableManger.getTableColumns(TABLES.TEAM_ATTENDANCE))));
            const passingData = {
                columnData: deepClone(attendanceColumn),
                rowData,
                filter: AttendanceService.apiTeamConfig['filter'],
                originalData: rowData
            };
            setTeamAttendance(passingData);
            setTotalPageCount(parseInt(filterConfig.totalPage));
            setCurrentPage(parseInt(filterConfig.page)+1);
            // if(AttendanceService.apiTeamConfig['searchField']){
            //     setCurrentPage(parseInt(filterConfig.page));
            // }
            setTotalCount(parseInt(filterConfig.numberOfRecords))
        }
    }, [attendanceData, reload]);

    useEffect(() => {
        if (!Utility.isEmpty(biometricDetail?.details)) {
            setShowBiometricSync(true);
        }
    }, [biometricDetail]);

    const changeShiftColumnPosition = (columns) => {
        if (columns) {
            const shiftColumn = columns.find(c => c.columnCode === COLUMN_CODE.ATTENDANCE_TEAM.SHIFT);
            if (shiftColumn) {
                const shiftIndex = columns.findIndex((c) => c.columnCode === COLUMN_CODE.ATTENDANCE_TEAM.SHIFT);
                columns.splice(shiftIndex, 1);
                columns.splice(3, 0, shiftColumn);
            }
        }
        return columns;
    }

    const loadAttendance = async (config) => {
        try {
            showLoader();
            AttendanceService.apiTeamConfig = config;
            await dispatch(fetchTeamAttendance());
            removeLoader();
        } catch (err) {
            console.error('Error loading contacts: ', err);
        }
    };

    const fetchDependancies = async () => {
        const dependancy = await Promise.all([AttendanceService.getDesignation(), ShiftManagementService.getShifts(false)]);
        setDesignations(dependancy[0]);
        const filteredshifts = dependancy[1]?.data?.filter((shift) => shift.employees?.length > 0);
        setShifts(filteredshifts);

        if (isProfessionalPlan()) {
            dispatch(fetchBiometricDetails());
        }
    }
    
    const onDeleteContact = (data) => {
        const attendanceId = data[0].id;
    };

    const onRowEdit = (data) => {
      setEditData(data.rowData.data);
      onClockEntry(data, "CLOCK_OUT", true)
    };

    const onSearch = (search) => {
        if (!search || search?.length >= 3) {
          setSearchName('')
            clearTimeout(searchTimer);
            searchTimer = setTimeout(() => {
                const config = {
                    ...AttendanceService.apiTeamConfig,
                    page: 0,
                    search: search
                };
                loadAttendance(config);
            }, 500);
        }
    };
    const newColumnAdded = (data) => {
        const columns = attendance.columnData;
        columns.push(data);
        setTeamAttendance({ ...attendance, columnData: columns });
    };

    const onFilter = (updatedList, queries) => {
    };

    const onRowAdd = (newRow) => {
    };
    const getDefaultOptions=()=>{
        let filter = attendance.filter;
        let arrayFilter = filter.split(',')
        let indexFilter = [];
        designations['designations'] = designations && designations['designations'] ? designations['designations']?.filter(e => e) : []
        let designationsList = (designations && designations['designations']) ? designations['designations']: []
        arrayFilter.forEach(design=>{
            if(design != "") {
                let ind = designationsList.findIndex(res=> (res==design));
                if(ind != -1 && filter !="") {
                    indexFilter.push(ind)
                }
            }

        })

        let shiftIndex = [];
        if (AttendanceService.apiTeamConfig['shift']) {
            const selectedShifts = AttendanceService.apiTeamConfig['shift'].split(",");
            shifts?.forEach((shift, index) => {
                if (selectedShifts.includes(shift.id)) {
                    shiftIndex.push([index]);
                }
            });
        }

        let json = {
            [TableManger.getColumnId(TABLES.TEAM_ATTENDANCE, COLUMN_CODE.ATTENDANCE_TEAM.DESIGNATION)]: indexFilter,
            [TableManger.getColumnId(TABLES.TEAM_ATTENDANCE, COLUMN_CODE.ATTENDANCE_TEAM.SHIFT)]: shiftIndex,
            designations: designations,
            shifts: shifts
        }
        return json;
    }

    const changeHideTerminatedValue = () => {
      if (!hideTerminated) {
        const config = {
          ...AttendanceService.apiTeamConfig,
          page: 0,
          searchString: "false",
          searchField: "isTerminated",
          userType:"all"
        };
        setHideTerminated(true);
        loadAttendance(config);
      } else {
        setHideTerminated(false);
        const config = {
          ...AttendanceService.apiTeamConfig,
          page: 0,
          searchString: "",
          searchField: "",
          userType:""
        };
        loadAttendance(config);
      }
    };


    const onSubRowClick = (rowIndex, rowData) => {
      
    };
    const getFunctionConfig = () => {
      let config = {
        "punchIn": punchIn,
        "punchOut": punchOut
      };
      return config;
    }
    const punchIn = (data) =>{
      console.log(data)
    }
    const punchOut = (data) =>{
      console.log(data)
    }
    const getExpandableView = (rowData) => {
        if (rowData.punchingLogs != null && rowData.punchingLogs.length > 0) {
          const functionConfig = getFunctionConfig();
            const rows = AttendanceDrillDownColumnConfig(rowData.punchingLogs,functionConfig,rowData);
            const columns = [];
            Object.values(COLUMN_CODE.ATTENDANCE_DRILL_DOWN).forEach(value => {
                columns.push({name: AttendanceDrillDownColumnName(value), key: value, type:'text', width:310});
            });
            let options = []
            if(PermissionUtils.hasAccess(MODULE.TEAM_REPORT,[ACTION.EDIT])) {
              options.push(
                {
                  // icon: DKIcons.ic_edit,
                  title: "Edit",
                  className:'p-0 text-app fw-m text-underline',
                  onClick: (data) => {
                      let obj = {
                        ...data,
                        rowIndex:data.rowIndex
                      }
                      setEditData(data.rowData.data)
                      if(data.rowData.type == 'Exit') {
                        onClockEntry(obj, "CLOCK_OUT", true,true)
                      } else {
                        onClockEntry(obj, "CLOCK_IN", true,true)
                      }
                  }
              }
              )
            }
            const actionColumn = {
              key: 'actions',
              name: "Action",
              className:'p-0',
              type: INPUT_TYPE.BUTTON,
              width: 100,
              options: options
          }
            let modifyColumns = [
              PermissionUtils.hasAccess(MODULE.TEAM_REPORT, [ACTION.EDIT]) ? actionColumn:{}, 
            ...columns
          ];
          if(TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED)) {
            modifyColumns = [...modifyColumns,{
              key: 'attachments',
              name: "Attachments",
              className: 'p-0',
              type: INPUT_TYPE.TEXT,
              width: 250,
              systemField: true,
              editable: false,
              hidden: !TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED),
              uiVisible: true,
              renderer: (data) => {
                return <div className="pt-s">{attachmentColumnData(data.rowData.attachments)}</div>;
              }
            }]
          }
            return (
              <div className="bg-gray2 parent-width" >
                <DKDataGrid
                    allowBulkOperation={false}
                    allowColumnEdit={false}
                    allowColumnDelete={false}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    allowRowEdit={false}
                    allowExpand={false}
                    allowDataExport={false}
                    isActionEnabled={false}
                    onRowOpenBtnHidden={true}
                    isHeaderHidden={true}
                    columns={modifyColumns}
                    rows={rows}
                    onRowClick={onSubRowClick}
                    needTrailingColumn={true}
                    width={width}
                     />
              </div>
            );
        } else {
            return (
                <div
                  className="p-h-xxl bg-gray1 parent-width column align-items-center justify-content-center"
                  style={{ height: 30 }}
                >
                  <DKLabel text="No data available" className="mt-r fs-m" />
                </div>
              );
        }
    }
    const windowSizeUpdated = () => {
      setWidth(SideBarService.getContainerWidth())
  };

  const attachmentColumnData = (value) => {
    if (value && value[0]) {
      return value.map(v => { return (<DKTooltipWrapper content={getFileName(v)} tooltipClassName="warning-tooltip-prop"><div onClick={() => downloadDocument(v)} className={"row"} ><img className={"cursor-hand"} style={{ width: 18 }} src={Utility.getFileIcon(getFileName(v))} /></div></DKTooltipWrapper>) })
    } else {
      return '-'
    }
  }
    const updateRowExpanded = data => {
        let {rowIndex, rowData} = data;
        const updatedAttendance = {...attendance};
        updatedAttendance.rowData[rowIndex] = {...rowData};
        setTeamAttendance(updatedAttendance);
    }

    const onClockEntry = (data, type,isEdit,isFromPunchlog) => {
      EmployeeListService.getUserDetailsByIamUserId(data?.rowData?.data?.iamUserId).then(
        res=>{
          if(res.status=="OK") {
            setEnableSave(true)
            setSelectedUserDetails(res.user)
            
          }
        }
      ).catch(error=>{
        setEnableSave(true)
        setSelectedUserDetails(true)
        
      })
      const today = moment(new Date()).startOf('day');
      const selectedDate = moment(selectYear.startDate, FORMAT.YYYYMMDD).startOf("day");
      if (selectedDate.isAfter(today)) {
        showAlert(t("PROXY_ATTENDANCE_FUTURE_ERROR"), "");
        return;
      }
      let attendanceDetails = isFromPunchlog ? deepClone(data.rowData.data) :deepClone(attendanceData.attendances[data.rowIndex]);
      if (type === ATTENDANCE_TYPE.CLOCK_OUT && !attendanceDetails.clockIn && !isFromPunchlog) {
        showAlert(t("CLOCK_IN_FIRST_ERROR"), "");
        return;
      }

      attendanceDetails['allowProxyPunch'] =  attendanceDetails?.punchingLogs?.length !=0 ? true: false
      setSelectedAttendance(attendanceDetails);
      const clockInAction =( attendanceDetails.clockIn && isEdit) ? FORM_ACTIONS.EDIT : FORM_ACTIONS.ADD;
      const clockOutAction = (attendanceDetails.clockOut && isEdit)? FORM_ACTIONS.EDIT : FORM_ACTIONS.ADD;
      setAttendancePopupData({
        action:
          isEdit ? isEdit: (type === ATTENDANCE_TYPE.CLOCK_IN ? clockInAction : clockOutAction),
        type,
        date: moment(selectYear.startDate).format(FORMAT.DDMMYYYY),
        employeeName: isFromPunchlog ? data?.rowData?.parentRowData?.data?.employeeName : attendanceDetails.employeeName,
        iamUserId: attendanceDetails.iamUserId,
        clockIn: isFromPunchlog? attendanceDetails.punchAt : attendanceDetails.clockIn,
        clockOut: isFromPunchlog? attendanceDetails.punchAt : attendanceDetails.clockOut,
        attachments: isFromPunchlog? attendanceDetails.attachments :[],
        isuserDetailsLoaded:false,
        isEdit: isEdit,
        isFromPunchlog: isFromPunchlog,
        id:   isFromPunchlog ? data?.rowData?.data?.id: data?.id,
        allowProxyPunch: !isEdit,
        remark: data?.rowData?.remark,
        parentRowData: data?.rowData?.parentRowData
      });
      setShowAttendancePopup(true);
    };

    const onCloseAttendancePopup = () => {
        setShowAttendancePopup(false);
        setPunchingError(null)
        setSelectedUserDetails(null);
        setEnableSave(false);
    }

    const addAttendance = (time, r, dataParam) => {
      let isTerminated = isUserTerminated(attendancePopupData.date)
      if (selectedUserDetails && selectedUserDetails.dateOfJoining) {
        let DOJ = selectedUserDetails.dateOfJoining;
        if (((Utility.isEmpty(DOJ)) || (!moment(selectYear.startDate).isBefore(moment(DOJ))) || (moment(selectYear.startDate).isSame(moment(DOJ), 'day'))) && isTerminated) {
          // continue;
        } else if(!isTerminated) {
          attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_OUT ? showToast(i18next.t("CLOCK_OUT_TERMINATION")) : showToast(i18next.t("CLOCK_IN_TERMINATION")) 
          return
        } else {
          if (attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_OUT) {
            showToast(i18next.t("CLOCK_OUT_DOJ"))
          } else {
            showToast(i18next.t("CLOCK_IN_DOJ"))
          }
          return;
        }
      }
      const punchTime = moment(selectYear.startDate).format(FORMAT.YYYYMMDD + " ") + time;
      const remark = r;
      if (!selectedAttendance.allowProxyPunch && attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_OUT && moment(punchTime).isSameOrBefore(moment(attendancePopupData.clockIn))) {
          showAlert(t("CLOCK_OUT_AFTER_CLOCK_IN_ERROR"), "");
        return;
      }
      if (!selectedAttendance.allowProxyPunch &&
        attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_IN &&
        attendancePopupData.clockOut &&
        moment(punchTime).isSameOrAfter(moment(attendancePopupData.clockOut))
      ) {
        showAlert(t("CLOCK_IN_BEFORE_CLOCK_OUT_ERROR"), "");
        return;
      }
      let logsToBeRemoved = [];
      if(selectedAttendance.punchingLogs) {
          if(attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_OUT) {
            logsToBeRemoved = selectedAttendance.punchingLogs.filter(log => moment(punchTime).isSameOrBefore(moment(log.punchAt)));
          } else {
            logsToBeRemoved = selectedAttendance.punchingLogs.filter(log => moment(punchTime).isSameOrAfter(moment(log.punchAt)));
          }
      }
      if (logsToBeRemoved.length > 0) {
        if (attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_IN) {
            const title = "All the entries before " + moment(punchTime).format(FORMAT.HHMM_A_2) + " will be removed.";
            setConfirmationPopupData({title, punchTime, remark,dataParam});
            setShowConfirmationPopup(true);
        } else {
            const title = "All the entries after " + moment(punchTime).format(FORMAT.HHMM_A_2) + " will be removed.";
            setConfirmationPopupData({title, punchTime, remark,dataParam});
            setShowConfirmationPopup(true);
        }
      } else {
          callAddAttendance(punchTime, remark,false,dataParam);
          setSelectedUserDetails(null)
          setEnableSave(false);
      }
      

    };
    const editAttendance = (data,remark,dataParam) =>{
      let params = {
        isPunchLog : false,
        id : editData.id,
        clockIn : moment(selectYear.startDate).format(FORMAT.YYYYMMDD + " ") + data.clockIn,
        clockOut : moment(selectYear.startDate).format(FORMAT.YYYYMMDD + " ") + data.clockOut,
        remark: remark ? remark:"",
        iamUserId: editData.iamUserId
      };

      if(TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED)) {
        params = {
          ...params,
          ...dataParam
        }
      }
      let isTerminated = isUserTerminated(attendancePopupData.date)

      if (!isTerminated) {
        attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_OUT ? showToast(i18next.t("CLOCK_OUT_TERMINATION")) : showToast(i18next.t("CLOCK_IN_TERMINATION")) 
        return
      }

      if (selectedUserDetails && selectedUserDetails.dateOfJoining) {
        let DOJ = selectedUserDetails.dateOfJoining;
        if ((Utility.isEmpty(DOJ)) || (!moment(selectYear.startDate).isBefore(moment(DOJ))) || (moment(selectYear.startDate).isSame(moment(DOJ), 'day'))) {
          // continue;
        } else {
          if (attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_OUT) {
            showToast(i18next.t("CLOCK_OUT_DOJ"))
          } else {
            showToast(i18next.t("CLOCK_IN_DOJ"))
          }
          return;
        }
      }
      showLoader("Updating... Please wait");
      
      Table.editProxyAttendance(params).then(
        (response) => {
          removeLoader();
          setShowAttendancePopup(false);
          setPunchingError(null)
          loadAttendance({ ...AttendanceService.apiTeamConfig });
          setEditData(null)
        },
        (error) => {
          
          showToast("Internal Server Error", TOAST_TYPE.FAILURE);
          removeLoader();
        }
      );
    }

  const isUserTerminated = (attendanceDate) => {
    if (!Utility.isEmpty(selectedUserDetails?.dateOfTermination)) {
      let terminationDate = moment(selectedUserDetails.dateOfTermination, FORMAT.YYYYMMDD)
      let attendance = moment(attendanceDate, FORMAT.DDMMYYYY)
      return terminationDate.isSameOrAfter(attendance, 'date') ? true : false
    }
    return true
  }
  const downloadDocument = (path) => {
    showLoader("Downloading document... Please wait");
    AttachmentService.getPresignedURL(path).then(
        (response) => {
            AttachmentService.downloadFile(response).then(
                (response) => {
                    removeLoader();
                    saveAs(response, getFileName(path));
                },
                (error) => {
                    removeLoader();
                }
            );
        },
        (error) => {
            removeLoader();
            showToast("Something went wrong", TOAST_TYPE.FAILURE);
        }
    );
  }

    const editPunchLogAttendance = (data,remark,dataParam) =>{
      let params = {
        isPunchLog : true,
        id : editData.id,
        clockIn : editData.type == "CLOCK_OUT" ? "": moment(selectYear.startDate).format(FORMAT.YYYYMMDD + " ") + data,
        clockOut : editData.type == "CLOCK_OUT" ? moment(selectYear.startDate).format(FORMAT.YYYYMMDD + " ") + data: "",
        remark: remark ? remark:"",
        iamUserId: editData.iamUserId,
        type: editData.type
      };
      if(TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED)) {
        params = {
          ...params,
          ...dataParam
        }
      }
      let isTerminated = isUserTerminated(attendancePopupData.date)

      if (selectedUserDetails && selectedUserDetails.dateOfJoining) {
        let DOJ = selectedUserDetails.dateOfJoining;
        if (((Utility.isEmpty(DOJ)) || (!moment(selectYear.startDate).isBefore(moment(DOJ))) || (moment(selectYear.startDate).isSame(moment(DOJ), 'day'))) && isTerminated) {
          // continue;
        } else if (!isTerminated) {
          attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_OUT ? showToast(i18next.t("CLOCK_OUT_TERMINATION")) : showToast(i18next.t("CLOCK_IN_TERMINATION")) 
          return
        } else {
          if (attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_OUT) {
            showToast(i18next.t("CLOCK_OUT_DOJ"))
          } else {
            showToast(i18next.t("CLOCK_IN_DOJ"))
          }
          return;
        }
      }
      showLoader("Updating... Please wait");
      Table.editProxyAttendance(params).then(
        (response) => {
          removeLoader();
          setShowAttendancePopup(false);
          loadAttendance({ ...AttendanceService.apiTeamConfig });
          setEditData(null)
          setPunchingError(null)
        },
        (error) => {
          if(error && error.code && error.code == "400" && error.errorMessage && error.errorMessage.includes("Punch time")) {
            setPunchingError({
              punchingLogError:error.errorMessage.replace("T"," ")
            })
          } else {
            setPunchingError(null)
            showToast("Internal Server Error", TOAST_TYPE.FAILURE);
          }
          removeLoader();
        }
      );
    }
    const callAddAttendance = (punchTime, remark, isClockIn,dataParam) => {
      setShowConfirmationPopup(false);
      let clockIn =
        attendancePopupData.clockIn != null
          ? moment(attendancePopupData.clockIn).format(FORMAT.YYYYMMDD_HHMM)
          : punchTime;
      if (
        (attendancePopupData.action === FORM_ACTIONS.EDIT &&
        attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_IN) || isClockIn
      ) {
        clockIn = punchTime;
      }
      let params = {
        punchAt: punchTime,
        clockIn,
        type: attendancePopupData.type,
        remark: remark,
        iamUserId: attendancePopupData.iamUserId,
        allowProxyPunch:attendancePopupData.allowProxyPunch,
        ...dataParam
      };
      if(TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED)) {
        params = {
          ...params,
          ...dataParam
        }
      }
      showLoader("Saving... Please wait");
      Table.proxyAttendance(params).then(
        (response) => {
          removeLoader();
          setShowAttendancePopup(false);
          setPunchingError(null)
          loadAttendance({ ...AttendanceService.apiTeamConfig });
        },
        (error) => {
          setEnableSave(true);
          if(error?.errorMessage?.includes("You are not allowed to clock out for this day as next day shift has already started.")) {
            showToast("You are not allowed to clock out for this day as next day shift has already started.", TOAST_TYPE.FAILURE);
          } else {
            showToast("Internal Server Error", TOAST_TYPE.FAILURE);
          }
          removeLoader();
        }
      );
    };

    const getQueryString = (start,end) => {
        const config = AttendanceService.apiTeamConfig;
        let query = ''
        if(isWeekFilterEnable()) {
          query = `clockIn>${moment(moment(start).format()).format("YYYY-MM-DD 00:00")},clockIn<${moment(moment(end).format()).format("YYYY-MM-DD 23:59")}`;
        } else {
          query = `clockIn>${moment(moment(start).format()).format("YYYY-MM-DD 00:00")},clockIn<${moment(moment(start).format()).format("YYYY-MM-DD 23:59")}`;
        }
        
        if (config.shift) {
            return `${query},shift_id=!${config.shift}`;
        } else {
            return query;
        }
    }
    const getSelectedDuration=(year)=> {
      let duration = {
        ...filterWeek
      }
      if(year) {
        duration['year'] = year;
      }
      if(filterWeek['start'] == '') {
          duration['start'] = moment().format()
      } else {
          let date = moment(duration['start']).format('DD/MM/');
          date += duration['year']
          duration['start'] = moment(date,'DD/MM/YYYY').format()
      }
      switch(selectedDuration) {
          
          case 'Week':
          let startWeekDate = duration['start'];
          let startWeek = moment(startWeekDate).startOf('week').add('d',1).add('week',counterForFilter)
          if(startWeek.format('YYYY') == moment().format('YYYY') || startWeek.format('YYYY') == moment().subtract('year',1).format('YYYY')) {
              duration['start'] = startWeek.format();
              duration['end'] = moment(startWeekDate).endOf('week').add('d',1).add('week',counterForFilter).format();
              duration['displayText'] = moment(startWeekDate).startOf('week').add('d',1).add('week',counterForFilter).format('Do MMM') + ' - ' +moment(startWeekDate).endOf('week').add('d',1).add('week',counterForFilter).format('Do MMM');
              duration['year'] = startWeek.format('YYYY');
          } else {
            showToast("Please choose the appropriate year and month.",TOAST_TYPE.FAILURE)
          }
          break;
      }
      const config = {
        ...AttendanceService.apiTeamConfig,
        page: 0,
        query: getQueryString(duration['start'],duration['end'])
      };
      loadAttendance(config);
      setFilterWeek(duration);
    }
    const nextOrPrev=(value) => {
      if(value == 'next'){
        counterForFilter = 1
      } else {
        counterForFilter = -1
      }
      getSelectedDuration()
  }
  const yearChange = (event) => {
    counterForFilter = 0;
    getSelectedDuration(event);
  }
  const onRowSelect = (data) =>{

  }

  const syncBiometricAttendance = () => {
    showLoader();
    const attendanceDate = moment(selectYear.startDate).format(FORMAT.YYYYMMDD);
    if (attendanceDate) {
        AttendanceService.syncBiometricAttendance(attendanceDate).then(
            (response) => {
                removeLoader();
                const config = {
                    ...AttendanceService.apiTeamConfig
                };
                loadAttendance(config);
            }, (error) => {
                removeLoader();
                showToast("Error while syncing biometric attendance.", TOAST_TYPE.FAILURE);
            }
        );
    }
  }
  const onCloseExportPopup = () => {
    setShowExportPopup(false);
    let unSelectRowData = attendance?.rowData;
    unSelectRowData = unSelectRowData?.map(row=>{
      return {
        ...row,
        selected: false
      }
    })
    if(!Utility.isEmpty(unSelectRowData)) {
      setTeamAttendance({
        ...attendance,
        rowData:unSelectRowData
      });
    }
  }

  return (
      <>
        <div className="parent-width">
            <div className="row">
                <div className="column bg-deskera-secondary p-r border-radius-m border-m parent-width banner-holder">
                    <DKLabel text='<span style="font-size:20px">🙋‍♂️</span> Need help getting started? Learn more about time tracking report.' />
                    <div className="row mt-r ml-l">
                        <DKButton
                            className="border-m bg-white"
                            title="Read"
                            onClick={AppManager.showComingSoonWarning}
                        />
                        <DKButton
                            className="border-m ml-r bg-white"
                            title="Watch"
                            onClick={AppManager.showComingSoonWarning}
                        />
                    </div>
                </div>
                {(isAdmin || PermissionUtils.hasAccess(MODULE.TEAM_REPORT,[ACTION.EXPORT,ACTION.IMPORT])) && <div className="column bg-deskera-secondary p-r border-radius-m border-m parent-width ml-l banner-holder">
                    <DKLabel text='<span style="font-size:20px">💼</span> Manage your time tracking report.' />
                    <div className="row mt-r ml-l">
                      {PermissionUtils.hasAccess(MODULE.TEAM_REPORT,[ACTION.IMPORT])&&<DKButton
                            title="Import Attendance"
                            icon={DKIcons.ic_import}
                            className="border-m bg-white"
                            onClick={() =>
                                RouteManager.navigateToPage(
                                    PAGE_ROUTES.IMPORT_ATTENDANCE,
                                    `module=${TABLES.ATTENDANCE}&origin=${PAGE_ROUTES.TEAM_ATTENDANCE}`
                                )
                            }
                        />}
                        {PermissionUtils.hasAccess(MODULE.TEAM_REPORT,[ACTION.EXPORT])&& <div className="row position-relative ml-r">
                            <DKButton
                                title={"Export Attendance"}
                                icon={DKIcons.ic_export}
                                className="border-m bg-white"
                                onClick={() => {
                                  setShowExportPopup(true);
                                }}
                            />
                        </div>}
                        {showExportPopup && <ExportAttendancePopup attendanceData={attendance} onClose={() => onCloseExportPopup()} />}
                    </div>
                </div>}
            </div>
            <DKLabel
                text={t("TEAM_ATTENDANCE_REPORT")}
                className="fw-m fs-l m-v-m "
            />
          <div className="row justify-content-between">
            <div className="d-flex align-items-center">
              
              {isWeekFilterEnable() && <><DKInput 
              className="min-w-70 "
              placeholder="Year"
              value={filterWeek.year}
              type={INPUT_TYPE.DROPDOWN}
              onChange={(value)=>{
                yearChange(value)
                
              }}
              dropdownConfig={{
                className: "",
                style: {},
                data:  [moment().format('YYYY'),moment().subtract('year',1).format('YYYY')],
                renderer: (index, obj) => {
                    /** How to render value in Dropdown in case of object **/
                    return <DKLabel text={`${obj}`} />;
                },
                onSelect: (index, obj) => {
                    // onValueChange(obj, "Quarter");
                },
            }}
              />
                <DKButton
                icon={DKIcons.ic_arrow_left}
                className="bg-gray1 border-m ml-m"
                onClick={()=>{
                  nextOrPrev('prev')
                }}
                />
                <DKButton
                className="bg-gray1 border-m ml-s"
                  title={selectedDuration}
                  disabled={true}
                />
                <DKButton
                icon={DKIcons.ic_arrow_right}
                className="bg-gray1 border-m ml-s"
                onClick={()=>{
                  nextOrPrev('next')
                }}
                />
                <DKLabel
                className="ml-m white-space-no-wrap "
                  text={filterWeek.displayText}
                />
                </>}
                {!isWeekFilterEnable() &&
                <div className="column "> 
                <DKButton
                  className="bg-app text-white  mr-r team-report-date"
                  title={
                    selectYear.startDate != ""
                      ? `${Utility.formatDate(
                          moment(selectYear.startDate).format(FORMAT.DDMMYYYY),
                          FORMAT.DDMMYYYY
                        )}`
                      : `${Utility.formatDate(
                          moment().format(FORMAT.DDMMYYYY),
                          FORMAT.DDMMYYYY
                        )}`
                  }
                  icon={calender}
                  onClick={(value) => {
                    const toggleBtn = selectYear.toggle ? false : true
                    pageScroll(!toggleBtn)
                    setYear({
                      toggle: toggleBtn,
                      startDate: selectYear.startDate,
                      endDate: selectYear.startDate,
                    });
                  }}
                />
                </div> 
                }
                {showBiometricSync &&
                    <DKButton
                        className="bg-white border-m"
                        title="Sync Biometric Attendance"
                        icon={DKIcons.ic_repeat}
                        onClick={() => {
                            syncBiometricAttendance();
                        }}
                    />
                }
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Toggle
                  className="border-n "
                  isOn={hideTerminated}
                  onChange={changeHideTerminatedValue}
                />
                <DKLabel
                  className="m-v-s ml-s mr-m"
                  text={"Hide Terminated Employees"}
                />
              </div>
              <DKSearchBar
                searchText={AttendanceService?.apiTeamConfig?.searchTerm || searchName}
                onSearch={onSearch}
              />
              <DKTooltipWrapper content={"Please enter atleast 3 characters to search"} tooltipClassName="warning-tooltip-prop ">
                    <DKIcon src={DKIcons.ic_info} className="ic-s cursor-hand mr-m" style={{ opacity: 0.4 }}/>
              </DKTooltipWrapper>
              <DKButton
                title="Filter"
                icon={funnel}
                className="bg-app text-white"
                onClick={() => {
                  showFormPopup({
                    tableName: TABLES.TEAM_ATTENDANCE,
                    displayName: "Filter",
                    defaultValues: getDefaultOptions(),
                    isCustomForm: true,
                    inputData: { ...attendance, dispatch, designations, shifts },
                    popupClass: "popup-overflow",
                  });
                }}
              />
            </div>
          </div>
          <div className="">
            {selectYear.toggle && (
              <DKCalendar
                className="position-absolute border-m shadow-m bg-white z-index-3 mt-s"
                isDateRange={false}
                selectedDate={new Date(selectYear.startDate)}
                onClose={() => {
                  pageScroll(true)
                  setYear({
                    toggle: false,
                    startDate: selectYear.startDate,
                    endDate: selectYear.startDate,
                  });
                }}
                onSelectDate={(date) => {
                  if (date) {
                    pageScroll(true)
                    setYear({
                      toggle: false,
                      startDate: date,
                      endDate: date,
                    });
                    const config = {
                      ...AttendanceService.apiTeamConfig,
                      page: 0,
                      query: getQueryString(date)
                    };
                    loadAttendance(config);
                  }
                }}
              />
            )}
          </div>

          <div
            className="row "
          >
            <div className="column parent-width flex-1 parent-height">
              <div className="column parent-width mb-s position-relative flex-1 ">
                <DataGridHolderPayroll
                  tableName={TABLES.TEAM_ATTENDANCE}
                  displayTableName={" "}
                  allowColumnEdit={false}
                  allowColumnDelete={false}
                  allowColumnShift={false}
                  allowSearch={false}
                  allowFilter={false}
                  allowExpand={true}
                  allowRowEdit={false}
                  onRowDelete={onDeleteContact}
                  onRowEdit={(data) => {
                    onRowEdit(data);
                  }}
                  onRowExpand={(data) => {
                    updateRowExpanded(data);
                  }}
                  refresh={refresh}
                  allowRowAdd={false}
                  addButtonConfig={[]}
                  allowDataExport={false}
                  gridData={attendance}
                  onSearch={onSearch}
                  onColumnAdd={newColumnAdded}
                  onFilter={onFilter}
                  filter={attendance.filter}
                  onRowAdd={onRowAdd}
                  onPaginationClick={(requestedPageNumber) => {
                    const config = {
                      ...AttendanceService.apiTeamConfig,
                      page: requestedPageNumber - 1,
                    };
                    loadAttendance(config);
                  }}
                  currentPage={currentPage}
                  totalPageCount={totalPageCount}
                  isActionEnabled={isActionEnabled}
                  isHeaderHidden={true}
                  onRowOpenBtnHidden={true}
                  contextMenu={true}
                  onClockIn={(data) => onClockEntry(data, "CLOCK_IN")}
                  onClockOut={(data) => onClockEntry(data, "CLOCK_OUT")}
                  isHideContextMenuWhenRowExpanded={true}
                  onSelection={onRowSelect}
                  onColumnShift={(data)=> setReload(!reload)}
                  module={MODULE.TEAM_REPORT}
                />
              </div>
              {/* {showPopup && (
                    <PopupWrapper
                        clickAction={catchClicks}
                        type={POPUP_TYPE.POPUP}
                        title={'Update Contact'}
                        btnList={popupBtnConfig}
                    >
                        <AddContact
                            populateFormData={editableContact}
                            passingInteraction={(callback: CallBackPayloadType) => {
                                parentChildInteraction(callback);
                            }}
                        />
                    </PopupWrapper>
                )} */}
              {showAttendancePopup && (
                <EmployeeAttendancePopup
                  onClose={() => onCloseAttendancePopup()}
                  addAttendance={(punchTime, remark, dataParam) => addAttendance(punchTime, remark, dataParam)}
                  editAttendance={(punchTime,remark,dataParam) => editAttendance(punchTime, remark, dataParam)}
                  editPunchLogAttendance={(punchTime,remark, dataParam) => editPunchLogAttendance(punchTime, remark, dataParam)}
                  data={attendancePopupData}
                  selectedUserDetails= {selectedUserDetails}
                  punchingError = {punchingError}
                  enableSave={enableSave}
                />
              )}
              
              {showConfirmationPopup && (
                <Popup onClose={() => setShowConfirmationPopup(false)}>
                  <DKLabel text={"Are you sure?"} className="fs-xl fw-m" />
                  <DKLabel
                    text={confirmationPopupData.title}
                    className="fs-l m-v-xxl"
                  />
                  <div className="row justify-content-end">
                    <DKButton
                      title="Cancel"
                      className="bg-gray1 mr-r"
                      onClick={() => setShowConfirmationPopup(false)}
                    />
                    <DKButton
                      title="OK"
                      className="bg-app text-white mr-r"
                      onClick={() =>{
                        const isClockIn = attendancePopupData.type == ATTENDANCE_TYPE.CLOCK_IN ? true:false
                        callAddAttendance(confirmationPopupData.punchTime, confirmationPopupData.remark, isClockIn,confirmationPopupData.dataParam)
                      }
                      }
                    />
                  </div>
                </Popup>
              )}
            </div>
          </div>
        </div>
      </>
    );
}
export default TeamReport;
